import { SliceZone } from '@prismicio/react';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import smoothscroll from 'smoothscroll-polyfill';

import { ComparisonTableSlice } from './ComparisonTableSlice';
import { EntityExampleSlice } from './EntityExampleSlice';
import { HeroSlice } from './HeroSlice';

import { BottomCtaSectionSlice } from '@/src/views/Referrals/BottomCtaSectionSlice';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

const components = {
  hero_section: HeroSlice,
  comparison_table: ComparisonTableSlice,
  bottom_cta_section: BottomCtaSectionSlice,
  pricing_comparison_table: EntityExampleSlice,
};

export function EntityCost(document) {
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <>
      <DocumentHead document={document} />
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </>
  );
}
